import $ from 'jquery';

class Modal {
    constructor() {
        this.initialize();
    }

    initialize() {
        this.$page = $('.page');
        this.$openButton = $('.js-modal-open');
        this.$closeButton = $('.js-modal-close');
        this.$modal = $('.js-modal');
        this.$body = $('body');
        this.modalOpen = false;
        this.addClickHandlers();
    }

    addClickHandlers() {
        this.$openButton.on('click', e => {
            e.preventDefault();
            this.toggleModal();
        });

        this.$closeButton.on('click', e => {
            e.preventDefault();
            this.toggleModal();
        });

        // Close modal by clicking on the black backdrop
        this.$modal.on('click', e => {
            if ($(e.target).hasClass('js-modal')) {
                e.preventDefault();
                this.closeModal();
            }
        });
    }

    toggleModal() {
        this.modalOpen ? this.closeModal() : this.openModal();
    }

    openModal() {
        this.modalOpen = true;
        this.$openButton.blur();
        this.$page.addClass('inactive');
        this.$modal.addClass('active');
        this.$body.on('keydown', e => this.handleKeydown(e));
    }

    closeModal() {
        this.modalOpen = false;
        this.$page.removeClass('inactive');
        this.$modal.removeClass('active');
        this.$openButton.blur();
        this.$body.off('keydown');
        $(window).scrollTop(0);
    }

    handleKeydown(e) {
        const $focused = $(e.target);

        if (e.which === 27) {
            // escape - close modal
            e.preventDefault();
            this.closeModal();
        } else if (e.which === 9 && e.shiftKey) {
            // tab + shift - cycle backwards within nav links
            if (
                this.$modal
                    .find('a')
                    .first()
                    .is($focused)
            ) {
                e.preventDefault();
                this.$closeButton.focus();
            }

            if (this.$closeButton.is($focused)) {
                e.preventDefault();
                this.$modal
                    .find('a')
                    .last()
                    .focus();
            }
        } else if (e.which === 9) {
            // tab - cycle within nav links
            if (
                this.$modal
                    .find('a')
                    .last()
                    .is($focused)
            ) {
                e.preventDefault();
                this.$closeButton.focus();
            }

            if (this.$closeButton.is($focused)) {
                e.preventDefault();
                this.$modal
                    .find('a')
                    .first()
                    .focus();
            }
        }
    }

    static init() {
        if ($('.js-modal').length > 0) {
            new Modal();
        }
    }
}

export default Modal;
